<template>
  <!-- Page Title -->
  <div class="page-title py-5 bg-custom-gradient">
    <div class="container">
      <div class="d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-between">
        <div><h3 class="text-white fw-bold">أنواع المواعيد</h3></div>
        <form class="search-form">
          <div class="d-flex flex-column flex-lg-row gap-3">
            <div class="position-relative">
              <div class="form-icon start">
                <i class="fa fa-search text-white"></i>
              </div>
              <input type="text" class="form-control bg-transparent text-white border-2 border-white" placeholder="البحث .." />
            </div>
            <div class="position-relative">
              <div class="form-icon end">
                <div class="radial-icon"></div>
              </div>
              <select class="form-select bg-transparent border-2 border-white text-white rounded-pill px-2">
                <option value="">إختيار</option>
                <option value="" selected>عرض الكل</option>
              </select>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Content -->
  <div class="container mt-5">
    <div class="row">
      <!-- Add New  -->
      <div class="col-12 col-xl-4 col-lg-6 mb-5">
        <a class="custom-card-link" href="#" data-bs-toggle="modal" data-bs-target="#addNewModal">
          <div class="card custom-card bg-transparent d-flex flex-column align-items-center justify-content-center py-lg-0 py-5">
            <img class="addnew-icon" src="@/assets/images/circle-plus_2x.png" alt="" />
            <h3 class="text-center f-4 fw-bold">إضافة نوع مواعيد جديد</h3>
          </div>
        </a>
      </div>
      <!-- Details Card -->

      <Card v-for="meeting in meetings" :key="meeting.id" :meeting="meeting" />
    </div>
  </div>
  <!-- Modal -->
  <Modal :form_img="false" :modal_img="require('@/assets/images/bookmark-plus_2x.png')" :close_btn_color="'white'" :modal_title="'إضافة نوع مواعيد جديد'" :name="'addNew'">
    <form>
      <div class="mt-3">
        <label for="title" class="fs-14px text-dark mb-2">العنوان</label>
        <input type="text" name="title" class="form-control bg-transparent border-2" />
      </div>
      <div class="mt-3">
        <div class="mb-1">
          <label for="platform" class="fs-14px text-black mb-2">منصة اللقاء</label>
        </div>
        <div class="radio-group radio-with-icon btn-group d-flex gap-2 justify-content-between" role="group" aria-label="Basic radio toggle button group">
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off" checked />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio1"><img src="@/assets/images/zm-02_2x.png" width="50" alt="" /></label>
            <span class="fs-14px">Zoom</span>
          </div>
          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio2"><img src="@/assets/images/MaskGroup1_2x.png" width="40" alt="" /></label>
            <span class="fs-14px">Google Meet</span>
          </div>

          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio3" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio3"><img src="@/assets/images/google-location.png" width="40" alt="" /></label>
            <span class="fs-14px">إجتماع فيزيائي</span>
          </div>

          <div class="d-flex flex-column align-items-center gap-2">
            <input type="radio" class="btn-check" name="btnradio" id="btnradio4" autocomplete="off" />
            <label class="btn btn-outline-primary bg-transparent d-flex align-items-center justify-content-center" for="btnradio4"><img src="@/assets/images/ic-phone-24px.svg" width="28" alt="" /></label>
            <span class="fs-14px">مكالمة هاتفية</span>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <label for="details" class="fs-14px text-black mb-2">وصف قصير</label>
        <textarea name="details" rows="5" class="form-control"></textarea>
      </div>
      <div class="mt-3 d-grid">
        <button class="btn btn-primary text-white rounded-pill py-3" data-bs-toggle="modal" data-bs-target="#meetingAddedModal" type="button">إضافة الآن</button>
      </div>
    </form>
  </Modal>
  <!-- Modal -->
  <Modal :form_img="false" :modal_img="require('@/assets/images/circle-checklist.svg')" :close_btn_color="'white'" :modal_title="'تم انشاء الموعد بنجاح'" :name="'meetingAdded'">
    <div class="fs-6 text-secondary my-4 text-center">يمكنك تخصيص الموعد او مشاركته مباشرة الآن</div>
    <div class="d-grid gap-3">
      <button class="btn btn-primary rounded-pill">تخصيص</button>
      <button class="btn btn-outline-primary rounded-pill d-flex align-items-center justify-content-center" type="button">
        <div class="svg-icon me-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="14.912" height="17.365" viewBox="0 0 14.912 17.365">
            <path
              id="Path_6"
              data-name="Path 6"
              d="M14.988,2H5.57A1.574,1.574,0,0,0,4,3.579v11.05H5.57V3.579h9.418Zm2.355,3.157H8.709a1.574,1.574,0,0,0-1.57,1.579v11.05a1.574,1.574,0,0,0,1.57,1.579h8.633a1.574,1.574,0,0,0,1.57-1.579V6.736A1.574,1.574,0,0,0,17.342,5.157Zm0,12.629H8.709V6.736h8.633Z"
              transform="translate(-4 -2)"
              fill="currentColor"
            />
          </svg>
        </div>
        نسخ الرابط

      </button>
    </div>
  </Modal>
</template>

<script>
// @ is an alias to /src
import Card from '@/components/Card.vue'
import Modal from '@/components/Modal.vue'
import {ref} from '@vue/reactivity'

export default {
  name: 'Home',
  components: {
    Card,
    Modal,
  },
  setup() {
    const meetings = ref([
      {
        id: 1,
        title: 'استشارة على الموقع',
        status: 'running',
        date: '10 JAN 22 / 10 OCT 20',
        duration: '30 دقيقة',
        platform: ['zoom', 'google'],
      },
      {
        id: 2,
        title: 'حجز موعد على الموقع',
        status: 'stopped',
        date: '9 JAN 22 / 11 JAN 20',
        duration: '190 دقيقة.',
        platform: ['zoom'],
      },
      {
        id: 3,
        title: 'أسئلة تقنية',
        status: 'inactive',
        date: '9 JAN 22 / 11 JAN 20',
        duration: '190 دقيقة.',
        platform: ['google'],
      },
    ])

    return {
      meetings,
    }
  },
}
</script>
